<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <div class="base-info">
    <p>
      {{ 'Collega una base con il bene corrente.' | translate }}
    </p>
    <p>
      {{ 'Una volta collegato dovrai salvare le modifiche apportate' | translate }}
    </p>
    <button mat-raised-button color="primary" (click)="handleCreateAndAdd()">Crea nuovo ed aggiungi ad oggetto</button>
  </div>
  <ui-table
    [rowSelection]="'single'"
    [fields]="fields"
    [pager]="pager$"
    [reload]="reload$"
    [itemsPage]="pageInfo.current"
    [itemsPerPage]="pageInfo.limit"
    (itemsPageChange)="applyChangePageHandler($event)"
    [filters]="filters$ | async"
    (select)="selectHandler($event)">
    <ng-template let-row="row">
      <div>
        <div><strong>test</strong></div>
        <div>{{row|json}}</div>
      </div>
    </ng-template>
    <div tableFilters>
      <ui-filters
        [dialogFilters]="MobileFiltersComponent"
        [showFiltersTitle]="false"
        (action)="applyFilterWithDelayHandler($event)">
        <app-base-filters #desktopFilter></app-base-filters>
      </ui-filters>
    </div>
  </ui-table>

  <div class="base-actions">
    <button
      mat-button
      mat-raised-button
      type="button"
      (click)="completeHandler()">
      {{ mainActionLabel }}
    </button>
  </div>
</mat-dialog-content>
